"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plaidItemType = exports.plaidAccountType = exports.achLoginType = exports.achBankAccountType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var achBankAccountType = _propTypes.default.shape({
  plaidAccountId: _propTypes.default.string,
  routingNumber: _propTypes.default.string,
  accountNumber: _propTypes.default.string,
  name: _propTypes.default.string,
  accountType: _propTypes.default.string,
  accountCategory: _propTypes.default.string,
  hasOwnerNames: _propTypes.default.bool
});

exports.achBankAccountType = achBankAccountType;

var achLoginType = _propTypes.default.shape({
  itemId: _propTypes.default.string,
  institutionName: _propTypes.default.string,
  accounts: _propTypes.default.arrayOf(achBankAccountType)
});

exports.achLoginType = achLoginType;

var plaidAccountType = _propTypes.default.shape({
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  accountType: _propTypes.default.string,
  accountCategory: _propTypes.default.string,
  accountNumberMask: _propTypes.default.string
});

exports.plaidAccountType = plaidAccountType;

var plaidItemType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  itemId: _propTypes.default.string,
  institution: _propTypes.default.string,
  accounts: _propTypes.default.arrayOf(plaidAccountType),
  assetsComplete: _propTypes.default.bool,
  assetsFailed: _propTypes.default.bool,
  loginRequired: _propTypes.default.bool,
  inProgress: _propTypes.default.bool,
  retryable: _propTypes.default.bool,
  status: _propTypes.default.string
});

exports.plaidItemType = plaidItemType;